import React, { useCallback, useEffect, useState } from 'react'
import TableCustom from '../../../components/table/tableCustom';
import InputTextField from '../../../components/input/inputTextField';
import { SearchOutlined } from '@mui/icons-material';
import { NavigateFunction, useLocation, useNavigate, useParams } from 'react-router-dom';
import TableRowCommon from '../../../components/table/TableRowCommon';
import { dateToView } from '../../../utils/date.utils';
import { useDispatch } from 'react-redux';
import OptionsButtonCustom from '../../../components/button/OptionsButtonCustom';
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice';
import { useTranslation } from 'react-i18next';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { routeName } from '../../../routes/routeName';
import { ThesisProgressApi } from '../../../api/thesis-progress/thesis-progress.api';
import StatusCustom from '../../../components/status/statusCustom';
import NavigateListCustom from '../../../components/navigation/NavigationListCustom';
import StateComponents from '../../../components/state-component/StateComponents';
import { status_e_the_sis_data, thesis_progress_status_data } from './enum/enum';
import moment from 'moment';
import { debouncedApiCall } from '../../../utils/app.utils';

export default function ListThesisProgress() {
    const navigate: NavigateFunction = useNavigate();
    const { t } = useTranslation();
    const { id } = useParams();
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up('md'));

    const [data, setData] = useState<any[]>([]);
    const dispatch = useDispatch();
    const location = useLocation()
    const pathname = location.pathname

    const [search, setSearch] = useState<any>('')
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("");
    const [sortType, setSortType] = useState<string>("ASC");
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy);
        setSortType(sortType);
    };
    const [student_detail, set_student_detail] = useState<any>(null);




    const [start_date, set_start_date] = useState<string>("");
    const [end_date, set_end_date] = useState<string>("");
    const [status, set_status] = useState<{ label: string, value: string }>();


    const headCells = [
        {
            id: "#",
            width: '80px',
            sortable: false,
            disablePadding: false,
            align: "start",
            label: t("ลำดับ"),
        },
        {
            id: "leave_type_name",
            width: '200px',
            sortable: false,
            disablePadding: false,
            align: "start",
            label: t("ชื่อวิทยานิพนธ์"),
        },

        {
            id: "user_updated",
            disablePadding: false,
            align: "center",
            width: '150px',
            label: t("วันที่ส่ง"),
        },
        {
            id: "user_updated",
            disablePadding: false,
            align: "center",
            width: '100px',
            label: t("เปอร์เซ็นต์ความคืบหน้า"),
        },

        {
            id: "last_updated",
            disablePadding: false,
            align: "center",
            width: '150px',
            label: t("สถานะ"),
        },
        {
            id: "action",
            disablePadding: false,
            align: "center",
            class: matches && data?.length > 0,
            width: '80px',
            label: "action",
        },
    ];

    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1;
        const { id_thesis_progress, thesis_name, created_date, thesis_progress_percent, thesis_progress_status, } =
            objData;

        const objRenderData = {
            key: id_thesis_progress,
            id: no,
            obj: objData,
            columns: [

                {
                    option: "TEXT",
                    align: "start",
                    label: no,
                },
                {
                    option: "TEXT",
                    align: "start",
                    label: thesis_name,
                },

                {
                    option: "TEXT",
                    align: "center",
                    disablePadding: true,
                    label: dateToView(created_date) || '-'
                },
                {
                    option: "TEXT",
                    align: "center",
                    disablePadding: true,
                    label: (thesis_progress_percent || 0) + '%' || '-'
                },
                {
                    option: "TEXT",
                    align: "center",
                    disablePadding: true,
                    label: thesis_progress_status ? (
                        <StatusCustom
                            sx={{ maxWidth: 'fit-content', px: 2.5 }}
                            // white_space='nowrap'
                            text={thesis_progress_status === 'APPROVE' ? t('ผ่านการตรวจสอบ') : thesis_progress_status === 'WAITING' ? t('รอพิจารณา') : t('ไม่ผ่านการตรวจสอบ')} type={
                                thesis_progress_status === 'APPROVE' ? 'ผ่านการตรวจสอบ' : thesis_progress_status === 'WAITING' ? 'รอพิจารณา' : 'ไม่ผ่านการตรวจสอบ' // i18n-ignore: StatusCustom color key
                            } />
                    ) : '-'
                },

                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches,
                    component: (
                        <div className='flex justify-center items-center'>
                            <OptionsButtonCustom
                                enableView
                                enableSend={thesis_progress_status === 'WAITING'}
                                onSendClick={() => {
                                    navigate(routeName.cms.DetailThesisProgress.replace(':id', `${id}`).replace(':id_thesis_progress', id_thesis_progress) + '?mode=SEND')

                                }}
                                onViewClick={() => {
                                    navigate(routeName.cms.DetailThesisProgress.replace(':id', `${id}`).replace(':id_thesis_progress', id_thesis_progress) + '?mode=VIEW')
                                }}

                            />
                        </div>
                    ),
                },
            ],
        };
        return <TableRowCommon {...objRenderData} />;
    };

    const loadData = useCallback(async () => {
        dispatch(setLoading());

        try {
            let condition: any = {};
            if (page) condition = { ...condition, page: page };
            if (pageLimit) condition = { ...condition, limit: pageLimit };
            if (search) condition = { ...condition, keyword: search };
            if (start_date) condition.sdate = moment(start_date).format("YYYY-MM-DD");
            if (end_date) condition.sdate = moment(end_date).format("YYYY-MM-DD");
            if (status) condition.status = status?.value;
            const res = await ThesisProgressApi.listThesisProgress(condition, id);
            if (res?.status < 300) {
                const data = res.data;
                const student_info = data?.data?.student_info || null;
                if (student_info) {
                    set_student_detail(student_info);
                }
                setData(data?.data?.items);
                setPage(data?.data?.meta.currentPage)
                setTotalItems(data?.data?.meta?.totalItems)
                dispatch(unsetLoading());
            } else {
                dispatch(unsetLoading());
            }
        } catch (error) {
            dispatch(unsetLoading());
        }
    }, [page, pageLimit, search, start_date, end_date, status]);

    useEffect(() => {
        loadData();
    }, [loadData]);



    // const handleDelete = async (id: any) => {
    //     await ExaminationCalendarStudentApi.delete(id).then((res: any) => {
    //         if (res.status < 300) {
    //             swalSuccess(t('ลบเอกสาร เรียบร้อยแล้ว'))
    //             loadData()
    //         }
    //     }).catch((error: any) => {
    //         console.log(error)
    //         swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
    //     })

    // }


    return (
        <div>
            <Box mb={2}>
                <NavigateListCustom
                    navigateData={[
                        {
                            key: "a",
                            name: t("ความคืบหน้าวิทยานิพนธ์/ดุษฎีนิพนธ์"),
                            pathName: routeName.cms.EThesisProgress,
                            disabled_match: true
                        },
                        {
                            key: "v",
                            name: t("ข้อมูลความคืบหน้า"),
                            pathName: pathname
                        },
                    ]}
                />
            </Box>
            <div className='flex flex-col justify-start items-start'>
                <Typography variant='h3'>
                    {t('ข้อมูลความคืบหน้า ')}
                </Typography>
                <Typography sx={{ marginTop: "20px" }}>
                    {`${t("ชื่อ - นามสกุล :")} ${student_detail?.student_first_name || "-"} ${student_detail?.student_last_name || "-"}  ${t("ฉายา :")} ${student_detail?.student_nickname || "-"} ${t("รหัสประจำตัวนักศึกษา :")} ${student_detail?.student_no || "-"} `}
                </Typography>
                <Typography>
                    {`${t("ระดับ :")} ${student_detail?.degree_name || "-"} ${t("หลักสูตร :")} ${student_detail?.faculty_name || "-"} ${t("ชั้นปีที่ :")} ${student_detail?.academic_year || "-"} `}
                </Typography>
            </div>


            <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
                <article className="w-full col-span-12 md:col-span-4 lg:col-span-4 sm:col-span-12">
                    <InputTextField
                        startAdornment={<SearchOutlined />}
                        placeholder={t("ค้นหาชื่อหัวข้อ")}
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            debouncedApiCall({ searchItem: e.target.value, setItem: setSearch })
                            // handleChangeValueSearch("leave_type_name", e.target.value);
                        }}
                    // value={inputValueSearch.leave_type_name}
                    />


                </article>
                {/* <article className="w-full col-span-12 md:col-span-4 lg:col-span-2 sm:col-span-12">

                    <FilterSelect
                        // value={inputValueSearch.year ?? ""}
                        labelId="year-id"
                        selectId="year-select-id"
                        options={[].map((year: any, index: number) => (
                            <MenuItem value={year} key={index + 1}>
                                {year}
                            </MenuItem>
                        ))}
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => { }
                            // handleChangeValueSearch("year", e.target.value)
                        }
                    />

                </article> */}
                <article className="w-full col-span-12 md:col-span-4 lg:col-span-2 sm:col-span-12">
                    <StateComponents
                        typeProps={[
                            {
                                seq: 1,
                                gridProps: {
                                    xs: 12
                                },
                                type: "DATE_RANGE2",
                                fieldProps: {
                                    placeholder: t("ช่วงวันที่"),
                                    handleChange: (st, end) => {
                                        set_start_date(st ?? "");
                                        set_end_date(end ?? "");
                                    },
                                    value: {
                                        end_date,
                                        start_date
                                    }
                                }
                            }
                        ]}

                    />
                    {/* <InputDatePicker
                        helperText={""}
                        allowClear
                        disableFuture
                        onChange={(e: any) => {
                            // handleChangeValueSearch("date", moment(e).format("YYYY-MM-DD"));
                        }} value={undefined} /> */}
                </article>
                <article className="w-full col-span-12 md:col-span-2">

                    <StateComponents
                        typeProps={[
                            {
                                seq: 1,
                                gridProps: {
                                    xs: 12,
                                },
                                type: "AUTO-COMPLETE",
                                fieldProps: {
                                    getOptionLabel: (op) => op?.label ? t(op.label) : "",
                                    labelId: "DWAD",
                                    onChange: (_, val) => set_status(val ?? null),
                                    placeholder: t("ทุกสถานะ"),
                                    options: thesis_progress_status_data || [],
                                    value: status || null
                                }
                            },
                        ]}
                    />

                    {/* 
                    <FilterSelect
                        // value={inputValueSearch.year ?? ""}
                        labelId="year-id"
                        selectId="year-select-id"
                        options={[].map((year: any, index: number) => (
                            <MenuItem value={year} key={index + 1}>
                                {year}
                            </MenuItem>
                        ))}
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => { }
                            // handleChangeValueSearch("year", e.target.value)
                        }
                    /> */}

                </article>

            </div>

            <section className="w-full mt-10">
                <TableCustom
                    tableMinWidth={1440}
                    tableFixedWidth
                    customScroll
                    page={page}
                    pageLimit={pageLimit}
                    sortBy={sortBy}
                    sortType={sortType}
                    headCells={headCells}
                    rowCount={totalItems}
                    rowsData={
                        data.map((data: any, i: any) => {
                            return renderData(data, i);
                        })
                    }
                    onSort={handleRequestSort}
                    setPageLimit={(value: number) => setPageLimit(value)}
                    setPage={(value: number) => setPage(value)}
                />
            </section>


        </div>
    )
}
